// The rail's call to action is the brand's progress bar. Exactly one of these
// stages is live at a time, and each owns a different button.
export const RAIL_STAGE = Object.freeze({
  // A DRAFT brand with nothing UPLOADED waiting to be extracted, or a
  // required type still missing — "Run AI extraction", disabled. Past DRAFT,
  // extraction is not on offer.
  UPLOAD: 'upload',
  // Every required type is uploaded and a document is waiting — "Run AI
  // extraction".
  EXTRACT: 'extract',
  // Extraction has been kicked off — "Review".
  REVIEW: 'review',
  // The sections are on screen and every one of them is decided or waiting
  // to be — "Send to Publish Queue". Covers IN_REVIEW and REVIEW_COMPLETED.
  PUBLISH: 'publish',
  // The current publication failed — "Republish" while retries remain, then
  // "Recover" for admins and a pointer to them for everyone else.
  REPUBLISH: 'republish',
  // Sent — a read-only callout, no button.
  QUEUED: 'queued',
  // A brand in a state the rail has nothing to offer for.
  NONE: 'none',
})

export const AWAITING_EXTRACTION_LABEL = 'Awaiting extraction'

// A type whose documents all failed extraction has nothing left to extract.
export const NO_DOCUMENTS_TO_EXTRACT_LABEL = 'No documents available to extract'

// A brand with dozens of files per type would push the rail's call to action
// off the screen, so each type lists this many and summarises the rest.
export const MAX_VISIBLE_FILES = 5

// The hover panel that lists every file for a type. Width and height are
// shared with the placement maths, so the two cannot drift apart — keep them
// equal to the `width` and `max-height` on
// `.document-status-rail__files-popover`.
export const POPOVER_WIDTH_PX = 288
export const POPOVER_MAX_HEIGHT_PX = 320
export const POPOVER_GAP_PX = 6
export const POPOVER_VIEWPORT_MARGIN_PX = 8
export const POPOVER_HIDE_DELAY_MS = 180
